exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".welcome-section {\n  text-align: center; }\n\n.behavior-section, .condition-section, .quality-section {\n  text-align: left; }\n\nbutton {\n  margin: 10px; }\n\n.btn-primary {\n  background-color: #8A627C;\n  color: white; }\n\n.btn-secondary {\n  background-color: #6c757d;\n  color: white; }\n\n.rounded-border {\n  border: 2px solid #8A627C;\n  /* Adjust color as needed */\n  border-radius: 15px;\n  /* Controls the corner rounding */\n  padding: 20px;\n  /* Adds spacing inside the border */\n  text-align: center;\n  /* Centers the content */\n  -webkit-box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  /* Optional: Adds a shadow for a better visual effect */\n  margin: 10px;\n  /* Adds space around the div */ }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/report-rir-lahidh-welcomepage/report-rir-lahidh-welcomepage.component.scss
// module id = ../../../../../src/app/report-rir-lahidh-welcomepage/report-rir-lahidh-welcomepage.component.scss
// module chunks = main